<template>
  <van-col class="w-80 color-88 font-10 pl-2 d-flex align-items-center" >
    <div class="d-flex cursor-pointer" @click="updateLike(status)">
      <van-icon v-if="isLike" class="mr-1" name="good-job" color="#2474ff" size="21"/>
      <van-icon v-else name="good-job-o" class="mr-1" size="21"/>
    </div>

    <div class="d-flex avalist" v-if="likeObj.userList && likeObj.userList.length >0">
      <div class="d-flex uList" v-for="(item, idx) in likeObj.userList.slice(0,6)" :key="idx">
        <avatar class="img" :avatar="item.avatarUrl"></avatar>
      </div>
      <van-popover placement="top-start"  class="d-flex avalist"
                   v-model="showList" trigger="click" >
        <div class="d-flex uList flex-wrap p-2 box-show">
          <avatar  v-for="(item, idx)  in likeObj.userList" :key="idx" class="img" :avatar="item.avatarUrl"></avatar>
        </div>
        <template #reference>
          <img class="more cursor-pointer" :class="'more-'+len" width="24"
               :src="moreAvaImg"/>
        </template>
      </van-popover>
    </div>
    <span :class="'more-'+len">{{likeObj.likeCount?likeObj.likeCount:0}}人点赞</span>
  </van-col>
</template>

<script>
  import avatar from './Avatar.vue'
  import Cookies from "js-cookie";
  import Vue from 'vue';
  import {
    Icon,
    Col,
    Popover,Grid, GridItem
  } from 'vant';
  Vue.use(Grid);
  Vue.use(GridItem);
  Vue.use(Popover);
  Vue.use(Col);
  Vue.use(Icon);
    export default {
        name: "likeComponent",
      data(){
        return {
          likeObj: {},
          curUser: '',
          tid: '',
          mainType: '',
          showRate: false,
          isLike: false,
          showList: false,
          moreAvaImg: '/static/img/session/avaMore.png',
          len: 0
        }
      },
      props: [
        'mainId',
        'type',
        'item',
        'status'
      ],
      components: {
        avatar,
      },
      created() {
        this.tid = this.mainId;
        this.mainType = this.type;
        if(this.item) {
          this.likeObj = this.item;
        }else {
          this.getLike();
        }
      },
      mounted() {
        this.curUser = JSON.parse(Cookies.get('u_info'));
      },
      methods: {
        //获取点赞
        getLike() {
          this.$store.dispatch('getLike', {mainType: this.mainType, mainId: this.tid}).then((res) => {
            if(res) {
              this.likeObj = res;
              this.isLike = res.currentUserLike;
              this.likeObj.likeCount = res.likeCount;
              if (this.likeObj.userList && this.likeObj.userList.length > 0) {
                this.len = this.likeObj.userList.length > 6 ? 6 : this.likeObj.userList.length;
              }
            }
          })
        },
        updateLike(status) {
          let model = {};
          model.mainId = this.tid;
          model.mainType = this.mainType;
          model.mainUserId =  this.curUser.id;
          model.rootId = this.tid;
          model.rootType = this.mainType;
          model.like = status; //标记是赞/踩
          if(!this.isLike) {
            this.addLike(model);
          }else {
            this.cancelLike(model);
          }
        },
        //点赞
        addLike(model) {
          this.$store.dispatch('addLike', {model: model}).then((res) => {
            this.isLike = true;
            if(this.likeObj && this.likeObj.likeCount) {
              this.likeObj.likeCount++;
            } else {
              this.likeObj.likeCount = 1;
            }

          }).catch(err => {
            if (err && err.response.data.consumerMessage) {
              this.$toast(err.response.data.consumerMessage);
            } else {
              this.$toast('操作失败');
            }
          })
        },
        //取消点赞
        cancelLike(model) {
          this.$store.dispatch('cancelLike', {model: model}).then((res) => {
            this.isLike = false;
            this.likeObj.likeCount--;
          }).catch(err => {
            if (err && err.response.data.consumerMessage) {
              this.$toast(err.response.data.consumerMessage);
            } else {
              this.$toast('操作失败');
            }
          })
        },

      }
    }
</script>

<style scoped lang="scss">
  $browser-default-font-size: 16px !default;
  @function pxTorem($px) {
    @return $px / $browser-default-font-size * 1rem;
  }
  @mixin calcleft($cur) {
    left:  #{-($cur - 1) * 6}px;
  }
  .avalist .uList {
    position: relative;
    z-index: 9;
  }
  .avalist .uList:nth-child(1) {
    @include  calcleft(1);
  }
  .avalist .uList:nth-child(2) {
    @include  calcleft(2);
  }
  .avalist .uList:nth-child(3) {
    @include calcleft(3);
  }
  .avalist .uList:nth-child(4) {
    @include  calcleft(4);
  }
  .avalist .uList:nth-child(5) {
    @include calcleft(5);
  }
  .avalist .uList:nth-child(6) {
    @include  calcleft(6);
  }
   @mixin recursive-item-right($cur) {
     position: relative;
     left: #{-($cur) * 6}px;
     z-index: 10;
   }
  .video-stat .more-1 {
    @include recursive-item-right(1);
  }
  .video-stat .more-2 {
    @include recursive-item-right(2);
  }
  .video-stat .more-3 {
    @include recursive-item-right(3);
  }
  .video-stat .more-4 {
    @include recursive-item-right(4);
  }
  .video-stat .more-5 {
    @include recursive-item-right(5);
  }
  .video-stat .more-6 {
    @include recursive-item-right(6);
  }
  .box-show {
    box-shadow: 10px 10px 5px #666666;
    max-width: pxTorem(208px);
  }

</style>
